import React from "react";
import { motion } from "framer-motion";
import { MailOutlined, FacebookOutlined, InstagramOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const scrollVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export const Footer = () => {
  return (
    <motion.div
      className="contact-section"
      variants={scrollVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="contact-container">
        <div className="caption-container">
          <h3 className="caption-title">Dr Shiny Angel</h3>
          <p className="caption-subtitle">
            Wife. Mother. Dentist.
            <br />
            Someone who Loves to Write.
          </p>
        </div>

        <h2 className="contact-heading">Connect With Us</h2>
        <p className="contact-subheading">
          Join a Community of Faith, Growth, and Purpose
        </p>

        <div className="contact-links">
          <a
            href="mailto:hercupoverflows.in@gmail.com"
            className="contact-link"
          >
            <MailOutlined className="contact-icon" /> hercupoverflows.in@gmail.com
          </a>
          <a
            href="https://www.facebook.com/her.cup.overflows.2024"
            className="contact-link"
          >
            <FacebookOutlined className="contact-icon" /> Facebook
          </a>
          <a
            href="https://www.instagram.com/hercupoverflows.in"
            className="contact-link"
          >
            <InstagramOutlined className="contact-icon" /> Instagram
          </a>
        </div>

        <div className="button-container">
          <Link to="/contact" className="contact-button-link">
            {/* Uncomment if you want the button */}
            {/* <Button
              type="primary"
              icon={<MailOutlined />}
              className="contact-button"
            >
              Join Our Community
            </Button> */}
          </Link>
        </div>
      </div>
    </motion.div>
  );
};
